module.exports = __webpack_public_path__ + "img/box-arrow-in-left.f125d266.svg";